import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ArabicHandleService } from '@doc/api/server-bo';
import { LanguageService } from '@doc/core';

import {
  Popover
} from 'bootstrap';


@Component({
  selector: 'doc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'das';

  constructor(public language: LanguageService, private arabicHandleService: ArabicHandleService
  ) {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(popoverNode => new Popover(popoverNode));
  }

  ngOnInit(): void {

    let lang = localStorage.getItem('lang');
    this.arabicHandleService.arabicManagement(lang);

  }

  ngAfterViewInit() {
    const observer = new MutationObserver(() => {
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop && backdrop.parentElement !== document.body) {
        document.body.appendChild(backdrop);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

}
